import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div>
          <div className="footer-brand">
            <img
              src="/images/PerfTech_logo_01.png"
              height="32"
              alt="PerfTech"
              className="footer-logo"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <span className="footer-reading">パーフテック</span>
          </div>
          <div className="footer-info">
            <p>〒103-0022</p>
            <p>東京都中央区日本橋室町1-11-12</p>
            <p>日本橋水野ビル7F</p>
          </div>
        </div>
        <div className="footer-nav">
          <Link to="/">Home</Link>
          <Link to="/service">Service</Link>
          <Link to="/company">Company</Link>
          <Link to="/recruit">Recruit</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </div>
      <div className="footer-copyright">
        <Link to="/privacy" className="footer-privacy-link">Privacy Policy</Link>
        <p>&copy; {new Date().getFullYear()} PerfTech Inc. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
